import { defineStore } from "pinia";
import { ref } from "vue";
import { useIntervalFn } from "@vueuse/core";
import { CountNotViewedNotifications } from "@/services/notification";
import { useAuthStore } from "@/stores/auth";

export const useNotificationStore = defineStore("NotificationStore", () => {
  const count = ref(0);
  const POLL_INTERVAL_MS = 20000;
  // Счётчик уходит в nrk-notification через прокси. Если в окружении прокси не
  // настроен, ответ будет ошибкой, а перехватчик ApiV1 покажет тост на каждый
  // запрос — поэтому после серии неудач опрос останавливается сам.
  const MAX_FAILURES = 10;
  let failures = 0;

  const fetchCount = async () => {
    const auth = useAuthStore();
    if (!auth.userData) return;

    try {
      const response = await CountNotViewedNotifications();
      count.value = response?.data ?? 0;
      failures = 0;
    } catch {
      failures += 1;
      if (failures >= MAX_FAILURES) {
        pause();
        console.warn("[notifications] опрос счётчика остановлен после ошибок");
      }
    }
  };

  const { pause, resume } = useIntervalFn(fetchCount, POLL_INTERVAL_MS, { immediate: false });

  const startCountTimer = () => {
    failures = 0;
    fetchCount();
    resume();
  };

  const stopCountTimer = () => {
    pause();
  };

  return {
    count,
    fetchCount,
    startCountTimer,
    stopCountTimer,
  };
});
